import React, { useRef, useState } from "react";
import Modal from "react-bootstrap/Modal";
import { Mensaje, MensajeSiNo, MensajeCapcha } from "../mensajes";

import "react-tabs/style/react-tabs.css";
import axios from "axios";
import { Dimmer } from "../spinner";
import { Input, Textarea } from "../../ui/inputs/Input";
import { DangerButton, SuccessButton } from "../../ui/buttons/Button";

export const UnidadMedida = (props) => {
  /*  variables de estados */

  const btnCancela = useRef();
  const btnAcepta = useRef();
  const [mostrar, setMostrar] = useState(false);
  const [titulo, setTitulo] = useState();
  const [msg, setMsg] = useState();
  const [mostrar1, setMostrar1] = useState(false);
  const [mostrar7] = useState(false);
  const [visible, setVisible] = useState(false);

  const [activate, setActivate] = useState(false);
  const [fechaSistema] = useState(localStorage.getItem("fechasistema"));
  const txtDescrp = useRef();
  const txtMonto = useRef();
  const txtIdc = useRef();
  const [deshabilitado] = useState(false);
  const [operacion, setOperacion] = useState(0);
  const [tabIndex, setTabIndex] = useState(0);
  const [values, setValues] = useState({
    idunidadmedida: "",
    descripcion: "",
  });

  let token = localStorage.getItem("jwtToken");
  let op = require("../../../src/modulos/datos");

  const onChange = (event) => {
    if (event.target.name === "descripcion") {
      event.target.value = event.target.value.toUpperCase();
    }
  };

  const Actualizar = (operacion) => {
    let endpoint = `${op.conexion}/api/comprasAlmacen/createUnidadMedida/${operacion}`;
    let body;
    setActivate(true);

    body = {
      idunidadmedida: parseInt(txtIdc.current.value),
      descripcion: txtDescrp.current.value.trim(),
    };

    console.log(body);

    axios
      .post(endpoint, body, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          props.onHideRenderizar();
          if (props.operacion === 1) {
            setTitulo("Notificacion");
            setMsg("Registro Creado Correctamente.");
            setMostrar(true);
          } else if (props.operacion === 2) {
            setTitulo("Notificacion");
            setMsg("Registro Modificado Correctamente.");
            setMostrar(true);
          } else if (props.operacion === 3) {
            setTitulo("Notificacion");
            setMsg("Registro Eliminado Correctamente.");
            setMostrar(true);
          }
        }
        setActivate(false);
      })
      .catch(function (error) {
        setTitulo("ERROR");
        setMsg(error.response.data.message);
        setMostrar(true);
        setActivate(false);
      });
  };

  const crearBitacora = (tipoope, nomtab, idtab) => {
    let endpoint = `${op.conexion}/api/comun/crearbitacora`;
    let body;
    setActivate(true);
    body = {
      tipope: tipoope,
      nomtabla: nomtab,
      idtab: idtab,
      nanio: null,
      nmesini: 1,
      nmesfin: 12,
      fecpag: null,
      numfac: null,
      monini: 0.0,
      monaju: 0.0,
      moncrea: txtMonto.current.value
        .trim()
        .replace(/\./g, "")
        .replace(",", "."),
      idusu: JSON.parse(props.idusuario),
      fecope: fechaSistema,
      fecreal: fechaSistema,
      cdirip: JSON.parse(props.ip),
      cdirmac: JSON.parse(props.mac),
    };
    axios
      .post(endpoint, body, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          console.log(response.data);
        }
        setActivate(false);
      })
      .catch(function (error) {
        setTitulo("ERROR");
        setMsg(error.response.data.message);
        setMostrar(true);
        setActivate(false);
      });
  };

  const crearMovimientoWeb = (operacion, nomtab, idtab) => {
    let endpoint = `${op.conexion}/api/comun/crearmovimientoweb/${operacion}`;
    let body;
    setActivate(true);
    body = {
      idmovi: null,
      nomtabla: nomtab,
      idtab: idtab,
      fecmovi: fechaSistema,
      riff: null,
      idcomer: idtab,
      idact: null,
      nanio: null,
      mess: null,
      tipdecla: null,
      numfac: null,
      prefac: null,
      operaper: null,
      actu: false,
      nmes: null,
      tip: null,
      peri: null,
    };
    axios
      .post(endpoint, body, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status == 200) {
        }
        setActivate(false);
      })
      .catch(function (error) {
        setTitulo("ERROR");
        setMsg(error.response.data.message);
        setMostrar(true);
        setActivate(false);
      });
  };

  const onChangeValidar = (e) => {
    e.preventDefault();
    var sigue = true;
    if (txtDescrp.current.value.trim() === "") {
      setTitulo("Error");
      setMsg("Debe Introducir la Descripción");
      sigue = false;
      txtDescrp.current.focus();
      setMostrar(true);
    } else if (sigue === true) {
      Actualizar(props.operacion);
    }
  };

  const blanquear = () => {
    setVisible(false);
    setMostrar1(false);
    setActivate(false);
    setValues({
      idunidadmedida: "",
      descripcion: "",
    });
    setTabIndex(0);
    setOperacion(0);
    setMsg("");
  };

  const handleCloseSi = () => {
    setMostrar1(false);
  };

  const handleCloseNo = () => {
    setMostrar1(false);
  };

  const handleCloseMensa = (e) => {
    e.preventDefault();
    setMostrar(false);
    if (
      msg == "Registro Creado Correctamente." ||
      msg == "Registro Modificado Correctamente." ||
      msg == "Registro Eliminado Correctamente."
    ) {
      blanquear();
      props.onHideCancela();
    }
  };

  const cancelar = (e) => {
    e.preventDefault();
    blanquear();
    props.onHideCancela();
  };

  return (
    <Modal
      {...props}
      size="xs"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      backdrop="static"
      keyboard={false}
      onShow={() => {
        setVisible(false);
        btnAcepta.current.focus();
        setOperacion(props.operacion);
        setTabIndex(0);
        if (props.operacion !== 1) {
          setValues(props.unidadMedida);
        }
      }}
    >
      <Modal.Header className="azulGradiant">
        <h3 className="fw-bold m-0">
          {props.operacion === 1
            ? "Agregar Unidad de Medida."
            : props.operacion === 2
              ? "Editar Unidad de Medida."
              : props.operacion === 3
                ? "Eliminar Unidad de Medida."
                : "Consultar Unidad de Medida."}
        </h3>
        <a
          className="fw-bold fs-6 text-light"
          type="button"
          ref={btnCancela}
          onClick={cancelar}
        >
          <i className="fa fa-times ms-2"></i>
        </a>
      </Modal.Header>
      <Modal.Body style={{ backgroundColor: "#fff", color: "" }}>
        <div className="col-6 m-0 p-0 mb-2">
          <Input
            label="Código:"
            disabled={true}
            name="idunidadmedida"
            value={values ? values.idunidadmedida : ""}
            id="inputCodigo"
            ref={txtIdc}
          />
        </div>
        <div className="col-12 m-0 p-0">
          <Textarea
            label="Descripción:"
            style={{ height: 70 }}
            disabled={operacion === 4 || operacion === 3 ? true : deshabilitado}
            name="descripcion"
            onChange={onChange}
            defaultValue={values ? values.descripcion.trim() : ""}
            id="inputDescripcion"
            ref={txtDescrp}
          />
        </div>
      </Modal.Body>
      <Modal.Footer>
        <SuccessButton
          disabled={operacion === 4 ? true : false}
          onClick={onChangeValidar}
          ref={btnAcepta}
        >
          Aceptar
        </SuccessButton>
        <DangerButton ref={btnCancela} onClick={cancelar}>
          Cancelar
        </DangerButton>
      </Modal.Footer>
      <Mensaje
        titulo={titulo}
        mensaje={msg}
        show={mostrar}
        onHide={handleCloseMensa}
      />
      <MensajeSiNo
        titulo={titulo}
        mensaje={msg}
        show={mostrar1}
        onHideSi={handleCloseSi}
        onHideNo={handleCloseNo}
      />
      <MensajeCapcha show={mostrar7} onHideAcepta={""} onHideCancela={""} />
      <Dimmer active={activate} inverted></Dimmer>
    </Modal>
  );
};
